var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_18928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4782 0.856445L0.856445 15.256H5.51744V38.0999H14.4011V26.8708C14.4011 25.0639 15.8296 23.5857 17.5758 23.5857H21.381C23.1272 23.5857 24.5557 25.0639 24.5557 26.8708V38.0999H33.4394V15.256H38.0999L19.4782 0.856445Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4384 38.7419H24.5548C24.2003 38.7419 23.9127 38.4542 23.9127 38.0997V26.8711C23.9127 25.4134 22.7765 24.2276 21.3801 24.2276H17.5749C16.1784 24.2276 15.0419 25.4134 15.0419 26.8711V38.0997C15.0419 38.4542 14.7546 38.7419 14.3997 38.7419H5.51696C5.16208 38.7419 4.87484 38.4542 4.87484 38.0997V15.8979H0.855965C0.581133 15.8979 0.337124 15.7233 0.248511 15.4634C0.159469 15.2036 0.245942 14.9159 0.46341 14.7481L19.0851 0.34856C19.3163 0.16962 19.6395 0.16962 19.8707 0.34856L38.4924 14.7481C38.7095 14.9163 38.7959 15.2036 38.7073 15.4634C38.6183 15.7233 38.3743 15.8979 38.0994 15.8979H34.0806V38.0997C34.0806 38.4542 33.7929 38.7419 33.4384 38.7419ZM25.1969 37.4576H32.7963V15.2558C32.7963 14.9009 33.084 14.6137 33.4384 14.6137H36.2193L19.4777 1.66792L2.73612 14.6137H5.51696C5.87185 14.6137 6.15909 14.9009 6.15909 15.2558V37.4576H13.758V26.8711C13.758 24.7054 15.4704 22.9434 17.5753 22.9434H21.3805C23.485 22.9434 25.1974 24.7054 25.1974 26.8711L25.1969 37.4576Z",
    fill: "#455A64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_18928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e514f36d13ff8240418b85a3c43d6688.svg";
export { ForwardRef as ReactComponent };